/* eslint-disable */
import React, { useState } from 'react';
import './styles/Transparency.css';

const Transparency = () => {
  const [activeTab, setActiveTab] = useState('tenders');

  const tenders = [
    {
      id: 1,
      title: 'Supply of Medical Equipment for Rapid Response Teams',
      reference: 'MOH/HS/2024/001',
      category: 'Procurement',
      value: '$250,000',
      deadline: '2024-12-15',
      status: 'Open',
      type: 'International'
    },
    {
      id: 2,
      title: 'Construction of One Health Laboratory Facilities',
      reference: 'MOH/HS/2024/002',
      category: 'Infrastructure',
      value: '$1,200,000',
      deadline: '2024-11-30',
      status: 'Open',
      type: 'International'
    },
    {
      id: 3,
      title: 'Training Services for Surge Capacity Development',
      reference: 'MOH/HS/2024/003',
      category: 'Consultancy',
      value: '$180,000',
      deadline: '2024-11-20',
      status: 'Open',
      type: 'National'
    },
    {
      id: 4,
      title: 'IT Equipment and Software for Disease Surveillance',
      reference: 'MOH/HS/2024/004',
      category: 'Procurement',
      value: '$75,000',
      deadline: '2024-10-25',
      status: 'Closed',
      type: 'National'
    }
  ];

  const audits = [
    {
      id: 1,
      title: 'Annual Financial Audit Report 2023',
      period: 'January - December 2023',
      auditor: 'Deloitte & Touche',
      date: '2024-03-15',
      status: 'Clean Opinion',
      downloadUrl: '#'
    },
    {
      id: 2,
      title: 'Special Audit: Emergency Response Funds',
      period: 'July - September 2024',
      auditor: 'KPMG South Sudan',
      date: '2024-10-10',
      status: 'Satisfactory',
      downloadUrl: '#'
    },
    {
      id: 3,
      title: 'Procurement Process Audit Q2 2024',
      period: 'April - June 2024',
      auditor: 'Internal Audit Unit',
      date: '2024-08-20',
      status: 'Compliant',
      downloadUrl: '#'
    }
  ];

  const performanceReports = [
    {
      id: 1,
      title: 'Quarterly Performance Report Q3 2024',
      period: 'July - September 2024',
      indicators: '15/18 Targets Met',
      rating: 'Excellent',
      date: '2024-10-05',
      downloadUrl: '#'
    },
    {
      id: 2,
      title: 'Annual Department Performance Review 2023',
      period: 'January - December 2023',
      indicators: '42/50 Targets Met',
      rating: 'Very Good',
      date: '2024-02-20',
      downloadUrl: '#'
    },
    {
      id: 3,
      title: 'Emergency Response Performance Assessment',
      period: 'Outbreak Response 2024',
      indicators: '8/10 Targets Met',
      rating: 'Good',
      date: '2024-09-15',
      downloadUrl: '#'
    }
  ];

  const policies = [
    {
      id: 1,
      title: 'Anti-Corruption and Ethics Policy',
      category: 'Governance',
      version: '2.1',
      effectiveDate: '2024-01-01',
      downloadUrl: '#'
    },
    {
      id: 2,
      title: 'Procurement Guidelines and Procedures',
      category: 'Operations',
      version: '1.5',
      effectiveDate: '2024-03-15',
      downloadUrl: '#'
    },
    {
      id: 3,
      title: 'Whistleblower Protection Policy',
      category: 'Governance',
      version: '1.2',
      effectiveDate: '2024-02-01',
      downloadUrl: '#'
    },
    {
      id: 4,
      title: 'Conflict of Interest Policy',
      category: 'Governance',
      version: '1.3',
      effectiveDate: '2024-01-15',
      downloadUrl: '#'
    }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'tenders':
        return (
          <div className="tab-content" id='transparency-page'>
            <div className="content-header">
              <h3>Current Tenders & Procurement</h3>
              <p>Open opportunities for suppliers and service providers</p>
            </div>
            <div className="tenders-grid">
              {tenders.map(tender => (
                <div key={tender.id} className="tender-card">
                  <div className="tender-header">
                    <div className="tender-badge">
                      <span className={`status ${tender.status.toLowerCase()}`}>
                        {tender.status}
                      </span>
                      <span className="type">{tender.type}</span>
                    </div>
                    <div className="tender-value">{tender.value}</div>
                  </div>
                  <h4>{tender.title}</h4>
                  <div className="tender-details">
                    <div className="detail-item">
                      <span className="label">Reference:</span>
                      <span className="value">{tender.reference}</span>
                    </div>
                    <div className="detail-item">
                      <span className="label">Category:</span>
                      <span className="value">{tender.category}</span>
                    </div>
                    <div className="detail-item">
                      <span className="label">Deadline:</span>
                      <span className="value deadline">
                        {new Date(tender.deadline).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </span>
                    </div>
                  </div>
                  <div className="tender-actions">
                    <button className="btn btn-primary">View Details</button>
                    <button className="btn btn-secondary">Download Tender</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      case 'audits':
        return (
          <div className="tab-content">
            <div className="content-header">
              <h3>Audit Reports & Financial Disclosures</h3>
              <p>Independent audit reports and financial accountability documents</p>
            </div>
            <div className="audits-list">
              {audits.map(audit => (
                <div key={audit.id} className="audit-item">
                  <div className="audit-info">
                    <h4>{audit.title}</h4>
                    <div className="audit-meta">
                      <span>Period: {audit.period}</span>
                      <span>Auditor: {audit.auditor}</span>
                      <span>Date: {new Date(audit.date).toLocaleDateString()}</span>
                    </div>
                  </div>
                  <div className="audit-status">
                    <span className={`status-badge ${audit.status.toLowerCase().replace(' ', '-')}`}>
                      {audit.status}
                    </span>
                    <button className="download-btn">Download Report</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      case 'performance':
        return (
          <div className="tab-content">
            <div className="content-header">
              <h3>Performance Reports</h3>
              <p>Department performance against strategic objectives and targets</p>
            </div>
            <div className="performance-grid">
              {performanceReports.map(report => (
                <div key={report.id} className="performance-card">
                  <div className="performance-header">
                    <h4>{report.title}</h4>
                    <span className={`rating ${report.rating.toLowerCase().replace(' ', '-')}`}>
                      {report.rating}
                    </span>
                  </div>
                  <div className="performance-details">
                    <div className="detail">
                      <span className="label">Period:</span>
                      <span className="value">{report.period}</span>
                    </div>
                    <div className="detail">
                      <span className="label">Performance:</span>
                      <span className="value indicators">{report.indicators}</span>
                    </div>
                    <div className="detail">
                      <span className="label">Published:</span>
                      <span className="value">{new Date(report.date).toLocaleDateString()}</span>
                    </div>
                  </div>
                  <button className="download-btn">Download Report</button>
                </div>
              ))}
            </div>
          </div>
        );

      case 'policies':
        return (
          <div className="tab-content">
            <div className="content-header">
              <h3>Governance Policies</h3>
              <p>Policies and guidelines ensuring transparency and accountability</p>
            </div>
            <div className="policies-grid">
              {policies.map(policy => (
                <div key={policy.id} className="policy-card">
                  <div className="policy-icon">📋</div>
                  <div className="policy-content">
                    <h4>{policy.title}</h4>
                    <div className="policy-meta">
                      <span className="category">{policy.category}</span>
                      <span className="version">v{policy.version}</span>
                    </div>
                    <div className="policy-date">
                      Effective: {new Date(policy.effectiveDate).toLocaleDateString()}
                    </div>
                  </div>
                  <button className="download-btn">Download</button>
                </div>
              ))}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="transparency-page">
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>Transparency & Accountability</h1>
            <p className="page-subtitle">
              Committed to open governance, financial transparency, and public accountability
            </p>
          </div>
        </div>
      </section>

      <section className="transparency-tabs">
        <div className="container">
          <div className="tabs-navigation">
            <button 
              className={`tab-nav ${activeTab === 'tenders' ? 'active' : ''}`}
              onClick={() => setActiveTab('tenders')}
            >
              <span className="tab-icon">📋</span>
              Tenders & Procurement
            </button>
            <button 
              className={`tab-nav ${activeTab === 'audits' ? 'active' : ''}`}
              onClick={() => setActiveTab('audits')}
            >
              <span className="tab-icon">💰</span>
              Audit Reports
            </button>
            <button 
              className={`tab-nav ${activeTab === 'performance' ? 'active' : ''}`}
              onClick={() => setActiveTab('performance')}
            >
              <span className="tab-icon">📊</span>
              Performance Reports
            </button>
            <button 
              className={`tab-nav ${activeTab === 'policies' ? 'active' : ''}`}
              onClick={() => setActiveTab('policies')}
            >
              <span className="tab-icon">⚖️</span>
              Governance Policies
            </button>
          </div>

          <div className="tab-content-wrapper">
            {renderContent()}
          </div>
        </div>
      </section>

      <section className="whistleblower-section">
        <div className="container">
          <div className="whistleblower-card">
            <div className="whistleblower-content">
              <div className="whistleblower-icon">🛡️</div>
              <div className="whistleblower-text">
                <h3>Report Concerns Anonymously</h3>
                <p>
                  Our confidential whistleblower protection system ensures you can report 
                  misconduct, fraud, or corruption without fear of retaliation.
                </p>
              </div>
            </div>
            <div className="whistleblower-actions">
              <button className="btn btn-primary">Report Anonymously</button>
              <button className="btn btn-secondary">View Protection Policy</button>
            </div>
          </div>
        </div>
      </section>

      <section className="transparency-stats">
        <div className="container">
          <h2>Our Commitment to Transparency</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Audit Compliance</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">$5.2M</div>
              <div className="stat-label">Transparent Procurement</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">48</div>
              <div className="stat-label">Public Reports Published</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">0</div>
              <div className="stat-label">Outstanding Audit Issues</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Transparency;